export function pathJoin(...parts: (string | undefined | null)[]): string {
  return (parts.filter((part) => part !== undefined && part !== null) as string[])
    .map((part) => part.replace(/^\/+|\/+$/g, ''))
    .join('/');
}
